import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useIntl } from 'react-intl';
import { DEFAULT_TEXT_COLOR, isImageFile, truncateMiddle } from '../../../common';
import { FileIcon } from '../../../common/components';
import * as styles from './Message.module.css';
export const FilesBlock = ({ message, clientId, setLoadedImages, }) => {
    if (!message.files)
        return null;
    const onImageLoad = () => {
        setLoadedImages((prevCount) => prevCount + 1);
    };
    return (_jsx(_Fragment, { children: message.files.map((file, index, filesArr) => {
            const { id, original_name, link } = file;
            const fileLink = `${link}?clientId=${clientId}`;
            if (isImageFile(original_name)) {
                let imgBlockStyle;
                if (!message.text && index === 0)
                    imgBlockStyle = { marginTop: '-10px' };
                if (index > 0 && isImageFile(filesArr[index - 1].original_name))
                    imgBlockStyle = { marginTop: '18px' };
                return (_jsx("div", { className: styles.image, style: imgBlockStyle, children: _jsx("a", { href: fileLink, download: original_name, children: _jsx("img", { src: fileLink, alt: original_name, onLoad: onImageLoad }) }) }, id));
            }
            let fileBlockStyle;
            if (!message.text && index === 0)
                fileBlockStyle = { marginTop: '0px' };
            if (index > 0 && isImageFile(filesArr[index - 1].original_name))
                fileBlockStyle = { marginTop: '18px' };
            return (_jsxs("div", { className: styles.file, style: fileBlockStyle, children: [_jsx(FileIcon, { color: message.channel === 'widget' ? '#FFF' : undefined }), _jsx("a", { href: fileLink, download: original_name, children: _jsx("span", { className: styles.fileName, children: truncateMiddle(original_name) }) })] }, id));
        }) }));
};
/** Временно решили писать 'File' если текста в реплае нет,
 * т.к. чаще всего это будет пустое сообщение с каким-то файлом, но без доработки на бэке узнать
 * есть файл или нет нельзя.
 */
export const ReplayBlock = ({ message }) => {
    const intl = useIntl();
    if (!message.reply || message.reply.deleted_at)
        return null;
    const { user_name, text } = message.reply;
    const lineColor = message.channel === 'widget' ? '#FFF' : DEFAULT_TEXT_COLOR;
    const lineHeight = user_name ? '40px' : '20px';
    return (_jsxs("div", { className: styles.replayContainer, children: [_jsx("div", { className: styles.replayLine, style: { background: lineColor, height: lineHeight } }), _jsxs("div", { children: [_jsx("div", { className: styles.replayTitle, children: user_name }), _jsx("div", { className: styles.replayContent, children: text || intl.formatMessage({ id: 'file' }) })] })] }));
};
